var map = {
	"./frame-1.png": "c44f",
	"./frame-2.png": "644a",
	"./frame-3.png": "3224",
	"./frame-4.png": "c8ee",
	"./frame-5.png": "6e2d",
	"./frame-6.png": "dff5",
	"./frame-bg.png": "9838"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d924";